import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_baevxea2c8: FaireBrandEntity = {
  token: "b_baevxea2c8",
  type: "brand",
  name: "Wattana",
  avatarUrl:
    "https://cdn.faire.com/fastly/39ddcb0249327fc8acbd0cdb706f3519cff97a818325439e50ba514aca3292b3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/636a42a381e630dc653ba45135dcddaa0177e1cde853c397e75233fc6b6f3bce.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/39ddcb0249327fc8acbd0cdb706f3519cff97a818325439e50ba514aca3292b3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/636a42a381e630dc653ba45135dcddaa0177e1cde853c397e75233fc6b6f3bce.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 144,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Wattana Chili Nut Crunch is a handcrafted Thai chili crisp packed with bold flavor and irresistible crunch. Made in small batches in Northern Thailand, each jar blends roasted cashews, crispy shallots, garlic, sesame and Thai chilis.\n\nOur two flavors—Original (barely any heat) and Spicy (with added heat)—are vegan, mostly organic, non-GMO, and made with traceable, single-origin ingredients. We work directly with small family farms, and our manufacturer is also our grower—so we’re involved from seed to jar.\n\nCreated by a Thai chef and French baker, Wattana is rooted in craft, sustainability, and the vibrant food culture of Thailand. Already a favorite among U.S. chili crisp fans, our jars are shelf-ready, visually striking, and built for strong repeat sales.\n\nPerfect for specialty grocers, gourmet shops, and customers looking for something unique, our chili crunch brings bold global flavor and serious crunch to any dish—from eggs and noodles to cheese boards and avocado toast.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:21.190Z",
    importedBy: "entity-db-cli",
  },
};
